module.exports = __webpack_public_path__ + "static/img/service.3c3fe9f9.png";